import * as actionTypes from './actionTypes';

export const setActive = selectedItem => {
    return {
        type: actionTypes.SET_ACTIVE,
        selectedItem
    }
}